import { render } from "./TopTourPackage.vue?vue&type=template&id=511f6740"
import script from "./TopTourPackage.vue?vue&type=script&lang=js"
export * from "./TopTourPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__